module.exports = __webpack_public_path__ + "static/media/climbing_view_1024.2f4c8034.webp";